module.exports = __webpack_public_path__ + "img/img82.03413490.png";